import * as THREE from 'three/build/three.module';
//import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';
import { J3RenderUtils } from './J3RenderUtils';
import { J3ModelsWrapper } from './J3ModelsWrapper';
import { J3Overlay } from './J3Overlay';
import { J3PanelBase } from './J3PanelBase';
import { J3LinkPanel } from './J3LinkPanel';
import { J3ImagePanel } from './J3ImagePanel';
//import { J3HomePanel } from './J3HomePanel';
import { J3GUIHelper } from './J3GUIHelper';
import { MouseAction } from './J3TypeList';
import { J3TagPanel } from './J3TagPanel';
import { J3DomeUtils } from './J3DomeUtils';
import { J3DrawUtils } from './J3DrawUtils';
import { J3CameraUtils } from './J3CameraUtils';
import { J3TagHelper } from './J3TagHelper';
import { J3BillboardHelper } from './J3BillboardHelper';
import { J3Billboar2DdHelper } from './J3Billboard2DHelper';

import { Object3D } from 'three';
import { J3SideNavPanel } from './J3SideNavPanel';
import { J3SideLinkPanel } from './J3SideLinkPanel';
import { J3ImageWindow } from './J3ImageWindow';
import { J3MapPanel } from './J3MapPanel';
import { J3MatterportSDK } from './J3MatterportSDK';
//Types
import { ImageWindowParam } from './J3TypeList';
import { J3SoundPanel } from './J3SoundPanel';
import { J3PrimitiveMaker } from './J3PrimitiveMaker';
import { J3ParticleMaker } from './J3ParticleMaker';
import { J3LoaderPanel } from './J3LoaderPanel';

export class J3ThreeSub extends EventTarget {
    container: THREE.Object3D = null;
    renderUtils: J3RenderUtils = null;
    cameraUtils: J3CameraUtils = null;
    domeUtils: J3DomeUtils;
    drawUtils; J3DrawUtils = null;
    overlay: J3Overlay;
    imagePanels: J3ImagePanel[] = [];
    guiHelper: J3GUIHelper;
    camera: THREE.camera;
    gyrocontrols: THREE.gyrocontrols;
    naviMenus: J3PanelBase[] = [];
    //box;
    //pmremGenerator;
    modelsWrapper: J3ModelsWrapper;
    tagHelpers: J3TagHelper[] = [];   //タグヘルパーの配列
    billboardHelpers: J3BillboardHelper[] = []; //ビルボードヘルパーの配列
    billboard2DHelpers: J3Billboar2DdHelper[] = []; //ビルボード2Dヘルパーの配列
    raycasterTop: THREE.Object3D = new Object3D();    //レイキャスター用のトップオブジェクト
    tagOnOffPanel: J3TagPanel;
    sideNavPanels: J3SideNavPanel[] = [];    //サイドパネル
    cameraParamIndex: number = 0;
    imageWindowParams: ImageWindowParam[] = [];
    domeComplete: boolean = false;
    modelComplete: boolean = false;
    mapPanel: J3MapPanel;
    soundPanel: J3SoundPanel;
    initialActionParam; // _skipModels==true時の初期移動ドームのactionParam
    skipModels: boolean = false;
    matterportSDK: J3MatterportSDK;
    primitiveMaker: J3PrimitiveMaker;
    particleMakers: J3ParticleMaker[] = [];
    loaderPanel: J3LoaderPanel;

    prevTime: number = 0.0;  //Updateループの前の時刻
    initialTime: number = 0.0;   //ループ開始時刻

    constructor(public debugLvl: number, public param, public scene, public top: THREE.Object3D) {
        super();
        this.top.add(this.raycasterTop);
    }

    SetCameraIndex(index: number = 0) {
        //カメラグループの対象インデックスを指定
        this.cameraParamIndex = index;
    }

    Show() { //オブジェクトを表示
        this.top.visible = true;
        //カメラ初期座標を上書き
    }
    Hide() { //オブジェクトを非表示
        this.top.visible = false;
    }

    Update() {
        // Mainからループコールされる
        if (!this.top.visible) return;  //非表示時は更新しない

        const currentTime = Date.now();
        const deltaTime = (currentTime - this.prevTime) / 1000;  //時間増分(sec)

        // タグ、ビルボードをカメラに正対させる
        if (this.cameraUtils) {
            //this.cameraUtils.Update(true);
            for (const tagHelper of this.tagHelpers) {
                tagHelper.Update(this.cameraUtils);
            }
            for (const billboardHelper of this.billboardHelpers) {
                billboardHelper.Update(this.cameraUtils);
            }
            for (const billboard2DHelper of this.billboard2DHelpers) {
                billboard2DHelper.Update(this.cameraUtils);
            }
        }
        //ドーム
        if (this.domeUtils) {
            this.domeUtils.Update();
        }

        if (this.param.overall.doAnimation) {
            // Animation
            // Models
            const pModels = this.param.models;
            for (const model of pModels) {
                if (model.enable) {
                    //console.log('model group', model.group);
                    for (const elem of model.data) {
                        if (elem.animation.enable) {
                            this.modelsWrapper.Rotate(elem.animation.rotSpeed);
                        }
                    }
                }
            }
        }

        //パーティクル
        if (this.param.particles) {
            //console.log('particleMakers.length', this.particleMakers.length);
            for (const particleMaker of this.particleMakers) {
                particleMaker.Update(deltaTime);
            }
        }

        //マップの位置を更新
        if (this.mapPanel) {
            if (this.param.matterport && this.param.matterport.enable) {
                //MatterportSDKコンテンツの場合
                if (this.matterportSDK) {
                    const userPosition: THREE.Vector3 = this.matterportSDK.position;
                    const rotation: THREE.Vector2 = this.matterportSDK.rotation;
                    const azimuthalAngle = -rotation.y * Math.PI / 180.0;
                    this.mapPanel.PlotPosition(userPosition, azimuthalAngle);
                }
            } else {
                //MatterportSDKコンテンツではない場合
                if (this.cameraUtils) {
                    const userPosition = this.cameraUtils.controls.target;
                    const azimuthalAngle = -this.cameraUtils.controls.getAzimuthalAngle() + Math.PI;
                    this.mapPanel.PlotPosition(userPosition, azimuthalAngle);
                }
            }

        }

        this.prevTime = currentTime;    //前時刻の更新
    }

    SetCameraUtils(cameraUtils: J3CameraUtils) {
        this.cameraUtils = cameraUtils;
    }

    SetCameraParams(cameraParamIndex = 0, forceMove = false) {
        //カメラコントロール
        this.cameraParamIndex = cameraParamIndex;
        let offset = [0, 0, 1];
        const targetCameraParam = this.param.camera.group[this.cameraParamIndex];
        if (targetCameraParam.orbitControl.enable) {
            console.log('SetCameraParams', targetCameraParam.name);
            const porbit = targetCameraParam.orbitControl;
            offset = porbit.offset;
            this.cameraUtils.SetOrbitControls(this.container, porbit.target, porbit.offset, porbit.enableZoom, porbit.enablePan, porbit.enableDamping, porbit.dampingFactor,
                porbit.minDistance, porbit.maxDistance, porbit.minPolarAngle, porbit.maxPolarAngle,
                porbit.rotateSpeed, porbit.autoRotate, porbit.autoRotateSpeed);
        }
        if (targetCameraParam?.animation?.enable) {
            this.cameraUtils.SetAnimation(targetCameraParam.animation);
        }

        //カメラ位置とドーム
        const pDomes = this.param.domes;
        if (forceMove || pDomes.moveToInitialLocation) {
            for (const sphere of pDomes.spheres) {
                if (sphere.image == pDomes.initialImage) {
                    const position = sphere.position;
                    console.log('initial camera position', sphere.image, position);
                    this.domeUtils.goalPosition.set(position[0], position[1], -position[2]);
                    this.cameraUtils.SetOrbitPosition(position, offset);
                    break;
                }
            }
        }
    }
    ChangeCameraParams(cameraParamIndex = 0) {
        //カメラコントロール
        this.cameraParamIndex = cameraParamIndex;
        //let offset = [0,0,1];
        const targetCameraParam = this.param.camera.group[cameraParamIndex];
        if (targetCameraParam.orbitControl.enable) {
            console.log('ChangeCameraParams', targetCameraParam.name);
            const porbit = targetCameraParam.orbitControl;
            //console.log('porbit min/max', porbit.minDistance, porbit.maxDistance, porbit.minPolarAngle, porbit.maxPolarAngle);
            //offset = porbit.offset;
            this.cameraUtils.ChangeOrbitControlParam(porbit.enableZoom, porbit.enablePan, porbit.enableDamping, porbit.dampingFactor,
                porbit.minDistance, porbit.maxDistance, porbit.minPolarAngle, porbit.maxPolarAngle,
                porbit.rotateSpeed, porbit.autoRotate, porbit.autoRotateSpeed);

        }
    }

    /*
        SetOrbitCameraPositionByAngle(angle:number[] = [0,0,0], distance:number = 3.0){
            // OrbitControl周りの角度からカメラ位置を設定 [polar, azimuthal, not_used]
            if (!this.controls) return;
    
            const degToRad = Math.PI/180.0;
    
            const cpos:THREE.Vector3 = this.camera.position;
            const target:THREE.Vector3 = this.controls.target;
            const dist:THREE.Vector3 = cpos.distanceTo(target);
     
            const rxy = dist * Math.cos(angle[0] * degToRad); //Polar Angle
            const y1 = dist * Math.sin(angle[0] * degToRad);
            const z1 = rxy * Math.cos(angle[1] * degToRad);
            const x1 = rxy * Math.sin(angle[1] * degToRad);
            const offset = new THREE.Vector3(x1,y1,z1);
            const pos:THREE.Vector3 = new THREE.Vector3();
            pos.subVectors(this.controls.target, offset);
            console.log('angle', angle[0], angle[1], angle[2], 'dist', dist, 'rxy', rxy, 'x1', x1, 'y1', y1, 'z1', z1, 'offset', offset, 'target', this.controls.target, 'pos', pos);
            this.camera.position.set(pos.x, pos.y, pos.z);
            //this.LookAtControlTarget();
            console.log('orbit min', this.controls.minDistance, 'max', this.controls.maxDistance);
            console.log('camera.position', this.camera.position);
        }
    */

    GoToDomeByName(name: string, forceCamPosition: boolean = false, angle: number[] = [0, 0, 0], distance: number = 1.0) {
        //ドームへ
        console.log('GoToDomeByName', name, 'forceCamPosition', forceCamPosition, 'angle', angle, 'distance', distance);

        //ドーム
        const pDomes = this.param.domes;
        this.ChangeCameraParams(pDomes.inCameraIndex);
        //ドーム表示＆カメラ移動
        //this.cameraUtils.SetOrbitCameraPositionByAngle(angle, distance);
        const degToRad = Math.PI / 180.0;
        const dist = distance;
        const rxy = dist * Math.cos(angle[0] * degToRad); //Polar Angle
        const y1 = dist * Math.sin(angle[0] * degToRad);
        const z1 = rxy * Math.cos(angle[1] * degToRad);
        const x1 = rxy * Math.sin(angle[1] * degToRad);
        //const offset = new THREE.Vector3(x1,y1,z1);
        const offset: number[] = [x1, y1, z1];
        console.log('offset', offset);
        const markername = pDomes.marker.prefix + '_' + name;   //マーカーの接頭辞をつけてマーカー名を作成
        this.domeUtils.MoveTo(markername, true, offset, true);
        //メニューの変更
        if (pDomes.changeNavigation && pDomes.enableNaviList) {
            console.log('this.naviMenus', this.naviMenus);
            for (const panel of this.naviMenus) {
                panel.HideButton(); //いったん非表示にする
                for (const name of pDomes.enableNaviList) {
                    //console.log('name', panel.name, name );
                    if (panel.name == name) {
                        panel.ShowButton();
                        break;
                    }
                }
            }
        }
    }

    GoTo3DModel() {
        //3Dモデルビューへ
        console.log('GoTo3DModel');
        this.modelsWrapper.Show();
        for (const tagHelper of this.tagHelpers) {
            tagHelper.ShowTag();
        }
    }

    SetPanels() {
        //const pDebug = this.param.debug;
        // パネル
        const pNav = this.param.navigation;
        const pNavData = pNav.data; //パネルボタンのデータ配列
        // タグパラメータ
        const pTags = this.param.tags;

        for (const data of pNavData) {
            const type = data.type.toLowerCase();
            if (type == 'text') {
                //テキスト（ホバーなし）
                const textPanel = new J3LinkPanel(this.debugLvl, data.name, data.enable, data.visible, data.targetID, data.btnClass, data.imageFile, data.linkURL);
                textPanel.DummyMethod();
                if (data.enable) this.naviMenus.push(textPanel);
            } else if (type == 'link') {
                //リンク
                const linkPanel = new J3LinkPanel(this.debugLvl, data.name, data.enable, data.visible, data.btnContainerID, data.btnID, data.btnClass, data.imageFile, data.linkURL);
                linkPanel.DummyMethod();
                if (data.enable) this.naviMenus.push(linkPanel);
            } else if (type == 'image') {
                //画像の表示・非表示
                const imagePanel = new J3ImagePanel(this.debugLvl, data.name, data.enable, data.show, data.visible, data.containerID, data.imageID, data.btnContainerID, data.btnID, data.iconOnFile, data.iconOffFile,
                    data.addTitle, data.titleText, data.imageQuery, data.imageFile, data.addLink, data.linkText, data.linkURL, data.target);
                imagePanel.addEventListener("change", (evt) => { this.ImageChanged(evt) });
                this.imagePanels.push(imagePanel);
                if (data.enable) this.naviMenus.push(imagePanel);
            } else if (type == 'tag') {
                if (this.renderUtils) {
                    //タグの表示・非表示
                    this.tagOnOffPanel = new J3TagPanel(this.debugLvl, data.name, data.enable, data.show, data.visible, data.btnContainerID, data.btnID, data.iconOnFile, data.iconOffFile);
                    this.tagOnOffPanel.addEventListener("change", (evt) => { this.TagOnOff(evt) });
                    //ボタンの初期値を探索し初期表示状態を設定
                    if (Array.isArray(pTags)) {
                        for (const taggroup of pTags) {
                            if (taggroup.enable) {
                                if (taggroup.groupid == this.tagOnOffPanel.id) {
                                    if (taggroup.initiallyOn) {
                                        this.tagOnOffPanel.Show();
                                    } else {
                                        this.tagOnOffPanel.Hide();
                                    }
                                    break;
                                }
                            }
                        }
                    }
                    if (data.enable) this.naviMenus.push(this.tagOnOffPanel);
                }
            } else if (type == 'side') {
                const sideNavPanel = new J3SideNavPanel(this.debugLvl, data.name, data.enable, data.targetID, data.buttonPrev, data.buttonNext);
                sideNavPanel.addEventListener('clicked', (evt) => { this.SideButton(evt) });
            } else if (type == 'sidelink') {
                let url: string = '';
                if (data.urls != null && data.urlIndex != null) {
                    url = data.urls[data.urlIndex];
                    console.log('sidelink', url);
                }
                const sideLinkPanel = new J3SideLinkPanel(this.debugLvl, data.name, data.enable, data.visible, data.targetID, data.buttonImage, data.function, url, data.linkTarget, data.css);
                sideLinkPanel.DummyMethod();
                if (data.enable) this.naviMenus.push(sideLinkPanel);
            } else if (type == 'imagewindow') {
                //アイコンボタンに紐付けしない画像
                const imageWindow = new J3ImageWindow(this.debugLvl, data.name, data.enable, data.visible, data.containerID, data.imageID,
                    data.titleQuery, data.titleText, data.imageQuery, data.imageFile, data.imageLink, data.linkURL, data.target);
                this.imageWindowParams.push({ imagewindow: imageWindow, subtype: data.subtype });
                if (data.show) {
                    imageWindow.Show();
                } else {
                    imageWindow.Hide();
                }
            } else if (type == 'map') {
                //サイドナビゲーション・マップ
                const mapIndex = data.mapIndex;
                const floorIndex = 0;
                this.mapPanel = new J3MapPanel(this.debugLvl, data.name, data.enable, data.show, data.visible, data.mapData[mapIndex], data.containerID, data.imageAlt, data.btnContainerID, data.btnID, data.iconOnFile, data.iconOffFile, data.class);
                console.log('Map Panel: state=', this.mapPanel.state);
                this.mapPanel.SetMappingParams(floorIndex, data.playerImageFile, data.playerScale);
                if (data.enable) this.naviMenus.push(this.mapPanel);
            } else if (type == 'sound') {
                //サウンド
                console.log('Sound: autoStart =', data.sutoStart);
                this.soundPanel = new J3SoundPanel(this.debugLvl, data.name, data.enable, data.autoStart, data.dataDirectory, data.data, data.index, data.volumeMaster, data.btnContainerID, data.btnID, data.iconOnFile, data.iconOffFile);
            }
        }

        // 補助描画
        const pOverall = this.param.overall;
        //軸ヘルパー
        this.drawUtils = new J3DrawUtils(this.scene);
        const pAxes = pOverall.axes;
        if (pAxes.enable) {
            this.drawUtils.DrawAxes(pAxes.position, pAxes.length);
        }
        //グリッドフロア
        const pGrid = this.param.overall.grid;
        if (pGrid.enable) {
            this.drawUtils.DrawGrid(pGrid.size, pGrid.divisions, pGrid.colorCenter, pGrid.colorGrid, pGrid.transparent, pGrid.opacity);
        }
        //GUIパネル
        const gui = this.param.gui;
        if (gui.enable) {
            this.guiHelper = new J3GUIHelper(this.scene, gui);
            this.guiHelper.addEventListener('change', (evt) => this.GUIChanged(evt));
        }
    }

    SideButton(evt) {
        //console.log(evt.detail.type);
        if (evt.detail.type == 'next') {
            this.modelsWrapper.SelectNext();
        } else if (evt.detail.type == 'prev') {
            this.modelsWrapper.SelectPrev();
        }
    }

    ImageChanged(evt) {
        console.log('ImageChanged', this.imagePanels.length, evt.detail.state, evt.detail.id);
        //イメージパネルの表示状態が変わった
        if (evt.detail.state) {
            //表示状態
            for (const imagePanel of this.imagePanels) {
                if (imagePanel.onOffButtonId != evt.detail.id) {
                    //該当パネル以外はクローズ
                    imagePanel.Hide(false, true);
                }
            }
        }
    }

    Billboard2DChanged(evt) {
        console.log('ImageChanged', this.imagePanels.length, evt.detail.state, evt.detail.id);
        //イメージパネルの表示状態が変わった
        if (evt.detail.state) {
            //for (const billboard2D of this.billboard2DHelpers) {
            //billboard2D.Show(false);
            //}
        } else {
            //表示状態
            for (const billboard2D of this.billboard2DHelpers) {
                billboard2D.Hide(false, true);
                //billboard2D.ShowAllTags();
                billboard2D.BackToCurrentTag();
            }
        }
    }

    TagOnOff(evt) {
        //タグの表示・非表示
        const groupid = evt.detail.id.split('_')[1];    //'btn_xxx'の'xxx'を取り出す
        this.TagOnOffGeneral(groupid, evt.detail.state);
    }

    TagOnOffGeneral(id: string = '', state: boolean = false) {
        //IDに応じて処置する
        //console.log('TagOnOffGeneral', id, state);
        //タグ
        for (const tagHelper of this.tagHelpers) {
            if (id == tagHelper.id) {
                //console.log('tag', id, 'changed to', state);
                if (state) {
                    tagHelper.ShowTag();
                    this.modelsWrapper.SelectItem(0);
                } else {
                    tagHelper.HideTag();
                }
                break;
            }
        }
    }

    Init(renderUtils: J3RenderUtils = null, _skipModels: boolean = false, _actionParam) {
        console.log('J3ThreeSub:Init _skipmodels', _skipModels);
        this.skipModels = _skipModels;
        //this.scene = scene;
        this.renderUtils = renderUtils;

        this.initialTime = Date.now(); //ループ前の時刻
        this.prevTime = this.initialTime;

        //const pDebug = this.param.debug;

        // HTML要素
        this.overlay = new J3Overlay();

        if (this.renderUtils) {
            const actionType: MouseAction = 'click';
            this.renderUtils.addEventListener(actionType, (evt) => this.MouseClicked(evt)); //オブジェクトがクリックされた
            // ライトプローブ
            //this.renderUtils.SetLightprobe();

            // アンビエント光源
            if (this.param.lights) {
                if (this.param.lights.ambient) {
                    const pAmbient = this.param.lights.ambient;
                    for (const elem of pAmbient) {
                        this.renderUtils.SetAmbientLight(elem.color, elem.intensity);
                    }
                }
                // 平行光源
                if (this.param.lights.directional) {
                    const pDirLight = this.param.lights.directional;
                    for (const elem of pDirLight) {
                        this.renderUtils.SetDirectionalLight(elem.color, elem.intensity, elem.position, elem.castShadow, elem.showHelper);    //color, intensity, position, castShadow
                    }
                }

                //半球光源
                if (this.param.lights.hemisphere) {
                    const pHemisphere = this.param.lights.hemisphere;
                    for (const elem of pHemisphere) {
                        this.renderUtils.SetHemisphereLight(elem.skycolor, elem.groundcolor, elem.intensity);    //sky color, gound color, intensity
                    }
                }

                // 点光源
                if (this.param.lights.point) {
                    const pPointLight = this.param.lights.point;
                    for (const elem of pPointLight) {
                        this.renderUtils.SetPointLight(elem.color, elem.intensity, elem.distance, elem.position, elem.showHelper);
                    }
                }

                // スポット光源
                if (this.param.lights.spot) {
                    const pSpotLight = this.param.lights.spot;
                    for (const elem of pSpotLight) {
                        this.renderUtils.SetSpotLight(elem.color, elem.intensity, elem.distance, elem.angle, elem.exponent, elem.position, elem.target, elem.castShadow, elem.showHelper);
                    }
                }

                //エリア光源
                if (this.param.lights.area) {
                    const pAreaLight = this.param.lights.area;
                    for (const elem of pAreaLight) {
                        this.renderUtils.SetSpotLight(elem.color, elem.intensity, elem.width, elem.height, elem.position, elem.rotation);
                    }
                }
            }

            // スカイボックス設定
            const pSkybox = this.param.skybox;
            if (pSkybox && pSkybox.enable) {
                const imagePath = pSkybox.imageDir + pSkybox.image;
                this.renderUtils.SetSkybox(imagePath, pSkybox.setEnvironmentMap);
            }

            // 環境マップ
            const pEnv = this.param.environmentMap;
            if (pEnv && pEnv.enable) {
                const imagePath = pEnv.imageDir + pEnv.image;
                this.renderUtils.SetEnvironmentMap(imagePath, pEnv.useLightprobe);
            }

            const pModels = this.param.models;
            const pTags = this.param.tags;
            if (!_skipModels) { //モデルとタグを詠み込む場合
                // GLTF/GLB形式のモデルデータを読み込むクラス        
                if (Array.isArray(pModels)) {
                    this.modelsWrapper = new J3ModelsWrapper(this.top, pModels);
                    this.modelsWrapper.addEventListener('AllModelsLoaded', (evt) => { this.ModelLoaded(evt) });
                    this.modelsWrapper.addEventListener('ChangeThru', (evt) => { this.IndexChange(evt) });
                    this.modelsWrapper.addEventListener('dispose', (evt) => { this.Disposed(evt) });
                    //this.modelsWrapper.SelectGroup(0);
                }


                // タグ画像
                if (Array.isArray(pTags)) {
                    for (const taggroup of pTags) {
                        if (taggroup.enable) {
                            //const wrapper = this.modelsWrapper.MakeEmptyObject(this.top, taggroup.position, taggroup.rotation);
                            const wrapper = new THREE.Object3D();
                            this.raycasterTop.add(wrapper);
                            const tagHelper = new J3TagHelper(taggroup.prefix, taggroup.groupid, taggroup.imageDir, wrapper, taggroup.faceTagToCamera, taggroup.initiallyOn);
                            this.tagHelpers.push(tagHelper);

                            for (const tag of taggroup.data) {
                                if (tag.load) {
                                    //console.log(tag.image, tag.imageposition, tag.footposition, tag.linecolor);
                                    //console.log('tag', tag.name);
                                    tagHelper.DrawTag(tag.name, tag.image, tag.imageposition, tag.footposition, tag.rotation, tag.scale, tag.drawLine, tag.linecolor, tag.linewidth);
                                }
                            }
                        }
                    }
                    //console.log('tagHelpers', this.tagHelpers.length);
                }
            }

            //360°写真ドーム（球体）
            const pDomes = this.param.domes;
            if (pDomes.enable) {
                this.domeUtils = new J3DomeUtils(this.cameraUtils, pDomes.imageDir, pDomes.marker.prefix, pDomes.marker.faceToCamera);
                this.domeUtils.addEventListener("complete", (evt) => { this.DomeImportComplete(evt) });
                this.domeUtils.addEventListener("imported", (evt) => { this.DomeImported(evt) });
                this.domeUtils.addEventListener('dispose', (evt) => { this.Disposed(evt) });
                this.domeUtils.addEventListener('moved', (evt) => { this.MoveComplete(evt) });
                //this.domeUtils.MakeDomes(this.raycasterTop, pDomes);    //360°ドームの作成

                this.initialActionParam = _actionParam;
                this.domeUtils.Init(this.raycasterTop, pDomes, _skipModels);
                //移動トゥイーンのパラメータ
                this.domeUtils.SetMoveParams(pDomes.duration, pDomes.easeBase, pDomes.easeEnd);
            }


            // ビルボード画像
            const pBills = this.param.billboards;
            if (Array.isArray(pBills)) {
                for (const billgroup of pBills) {
                    if (billgroup.enable) {
                        const wrapper = new THREE.Object3D();
                        this.raycasterTop.add(wrapper);
                        const billboardHelper = new J3BillboardHelper(wrapper, billgroup.prefix, billgroup.groupid, billgroup.enable, billgroup.imagecommon, billgroup.tagcommon, billgroup.data);
                        this.billboardHelpers.push(billboardHelper);
                    }
                }
            }
            if (this.debugLvl > 0) console.log('billboardHelpers.length', this.billboardHelpers.length);

            // ビルボード2D画像
            const pBill2D = this.param.billboard2D;
            if (Array.isArray(pBill2D)) {
                for (const billgroup of pBill2D) {
                    if (billgroup.enable) {
                        const wrapper = new THREE.Object3D();
                        this.raycasterTop.add(wrapper);
                        const billboard2DHelper = new J3Billboar2DdHelper(wrapper, billgroup.prefix, billgroup.groupid, billgroup.enable, billgroup.imagecommon, billgroup.tagcommon, billgroup.data, billgroup.debug);
                        billboard2DHelper.addEventListener("change", (evt) => { this.Billboard2DChanged(evt) });
                        this.billboard2DHelpers.push(billboard2DHelper);
                        console.log('billboard2DHelpers.length', this.billboard2DHelpers.length);
                    }
                }
                //if (this.debugLvl > 0) 
                console.log('billboard2DHelpers.length', this.billboard2DHelpers.length);
            }

            // プリミティブ
            const pPris = this.param.primitives;
            console.log('Material.side', THREE.DoubleSide);
            if (Array.isArray(pPris)) {
                for (const group of pPris) {
                    if (group.enable) {
                        const wrapper = new THREE.Object3D();
                        wrapper.name = group.groupid;
                        //
                        const primitiveMaker = new J3PrimitiveMaker();
                        for (const elem of group.data) {
                            if (elem.enable) primitiveMaker.MakePrimitive(wrapper, elem);
                        }
                        //先に子オブジェクトをaddしてから親オブジェクトのポジション、ローテーションを変えてトップにAddする
                        const p = group.position;
                        wrapper.position.set(p[0], p[1], p[2]);
                        const r = group.rotation;
                        const f = Math.PI / 180;
                        wrapper.rotation.set(f * r[0], f * r[1], f * r[2]);
                        console.log('wrapper', group.groupid, 'rotation', wrapper.rotation);
                        this.raycasterTop.add(wrapper);
                    }
                }
            }

            //パーティクル
            const pParticles = this.param.particles;
            if (Array.isArray(pParticles)) {
                for (const group of pParticles) {
                    //console.log('Particles', group.groupid);
                    const wrapper = new THREE.Object3D();
                    wrapper.name = group.groupid;
                    //
                    for (const elem of group.data) {
                        const particleMaker = new J3ParticleMaker();
                        if (elem.enable) {
                            particleMaker.MakeParticle(wrapper, elem);
                            this.particleMakers.push(particleMaker);
                        }

                    }
                    //先に子オブジェクトをaddしてから親オブジェクトのポジション、ローテーションを変えてトップにAddする
                    const p = group.position;
                    wrapper.position.set(p[0], p[1], p[2]);
                    const r = group.rotation;
                    const f = Math.PI / 180;
                    wrapper.rotation.set(f * r[0], f * r[1], f * r[2]);
                    this.raycasterTop.add(wrapper);
                }
            }
        }

        // Matterport SDK
        const pMatterport = this.param.matterport;

        if (pMatterport && pMatterport.enable) {
            console.log('Matterport');
            const index = pMatterport.mpIndex;  //使用するデータのインデックス
            this.matterportSDK = new J3MatterportSDK(this.debugLvl, pMatterport.containerID, pMatterport.key, pMatterport.mpData[index].spaceID, pMatterport.queryParam, pMatterport.mpData[index].startParam, pMatterport.billboards);
            this.matterportSDK.addEventListener('FloorChanged', (evt) => { this.FloorChanged(evt) });   //フロア変更時のイベント
        } else {
            console.log('Three.js');
            //MatterportSDKを使用しない場合は、#showcaseを削除する。これは一時的な対応なので改善する
            const mpContainer: HTMLElement = document.querySelector('#showcase') as HTMLElement;
            if (mpContainer) {
                mpContainer.remove();
            }
        }

        // Loader
        const pLoader = this.param.loader;
        if (pLoader) {
            console.log('Loader');
            let enable = pLoader.enable;
            if(_skipModels) enable = false;
            this.loaderPanel = new J3LoaderPanel(this.debugLvl, enable, pLoader.loaderID, pLoader.limitTime);
        }

        //ユーザインターフェース・パネル
        this.SetPanels();

    }

    HideEntryWindows() {
        if (this.domeComplete && this.modelComplete) {
            //ドームとモデルの両方の読み込み完了なら…
            for (const imageWindowParam of this.imageWindowParams) {
                // 'entry'ウィンドウを閉じる
                if (imageWindowParam.subtype == 'entry') {
                    imageWindowParam.imagewindow.Hide();
                }
            }
            if (this.loaderPanel) {
                this.loaderPanel.Hide();
            }
        }
    }
    DomeImported(evt) {
        //ドーム画像読み込み進行中
        if (this.imageWindowParams[0]) {
            const text = 'Imported Images: ' + evt.detail.number + '/' + this.param.domes.initialConnects.length;
            this.imageWindowParams[0].imagewindow.SetTitle(text);
            console.log('DomeImported', text);
        }
    }

    DomeImportComplete(evt) {
        //ドーム画像読み込み完了
        console.log('DomeImportComplete');
        this.domeComplete = true;
        this.HideEntryWindows();
        if (this.skipModels) {    //モデル・スキップ時は最初のドームへ
            //クエリパラメータで指定したドームへ
            console.log('Go to Dome', this.initialActionParam.name);
            const angle: number[] = (this.initialActionParam.angle) ? this.initialActionParam.angle : [0, 0, 0]; //カメラ視線方向
            const distance: number = (this.initialActionParam.distance) ? this.initialActionParam.distance : 1.0; //OrbitControl中心からのカメラ距離
            this.GoToDomeByName(this.initialActionParam.name, true, angle, distance);
        }
    }

    ModelLoaded(evt) {
        //モデル読み込み完了
        this.modelComplete = true;
        this.HideEntryWindows();
    }

    IndexChange(evt) {
        //console.log('IndexChange@J3ThreeSub', evt.detail.index, evt.detail.isMin, evt.detail.isMax);
        for (const sideNavPanel of this.sideNavPanels) {
            if (evt.detail.isMin) {
                sideNavPanel.AtMin();
            } else if (evt.detail.isMax) {
                sideNavPanel.AtMax();
            } else {
                sideNavPanel.InMid();
            }
        }

        //タグの処理
        if (this.modelsWrapper.tagConnect) {
            //console.log('tagID', evt.detail.tagID);
            if (evt.detail.tagID == 'NONE') {
                this.tagOnOffPanel.Hide();
            }
        }
    }

    FloorChanged(evt) {
        //Matterportスペースでフロアが変更されたときの処理
        console.log('FloorChanged', evt.detail.sequence);
        const floorSeq = evt.detail.sequence;
        this.mapPanel.ChangeMappingParams(floorSeq);
    }

    MouseClicked(evt) {
        //RenderUtilsでのマウスクリック時にコールされるアクション evt.detail.nameにクリックされたオブジェクトの名前が格納されている
        if (evt.detail.type == 'tag') {
            console.log('tag', evt.detail.name);
            //タグ（３Dモデル）
            this.TagClickedAction(evt.detail);
        } else if (evt.detail.type == 'marker') {
            //マーカー(ドーム)
            const markername = evt.detail.name;
            //const imagename = evt.detail.name.split('_')[1];  //接頭辞'mk_'を取り除く＝画像ファイル名
            console.log('MouseClicked', evt.detail.name);
            this.domeUtils.MoveTo(markername, false);
        } else if (evt.detail.type == 'billboard') {
            for (const helper of this.billboardHelpers) {
                //helper.ShowImage(evt.detail.name);
                helper.DoAction(evt.detail.name);
            }
        } else if (evt.detail.type == 'billboard2D') {
            for (const helper of this.billboard2DHelpers) {
                helper.DoAction(evt.detail.name);
            }
        }
    }

    TagClickedAction(detail) {
        //console.log(detail.name);
        const params = detail.name.split('_');  //タグ名は'groupid_name'となっている。たとえば、'tag1_onsitsu'
        //各タググループについて調べる
        for (const group of this.param.tags) {
            if (!group.clickAction) continue;    //clickAction=falseなら何もしない
            //グループを見つける
            if (group.groupid == params[1]) {
                for (const data of group.data) {
                    if (data.name == params[2]) {
                        //アクション処理
                        if (group.actionType.toLowerCase() == 'gotodome') {
                            //console.log(params[0], params[1], group.actionType, data.actionParam);
                            this.modelsWrapper.Hide();
                            for (const tagHelper of this.tagHelpers) {
                                tagHelper.HideTag();
                            }
                            //指定のドームへ
                            const angle: number[] = (data.actionParam.angle) ? data.actionParam.angle : [0, 0, 0]; //カメラ視線方向
                            const distance: number = (data.actionParam.distance) ? data.actionParam.distance : 1.0; //OrbitControl中心からのカメラ距離
                            this.GoToDomeByName(data.actionParam.name, true, angle, distance);
                            this.modelsWrapper.DisposeAll();
                            break;
                        }
                    }
                }
            }
        }
    }

    SetOrbitDirection(direction: string) {
        this.cameraUtils.SetOrbitDirection(direction);
    }
    SetOrbitSpeed(speed: number) {
        this.cameraUtils.SetOrbitSpeed(speed);
    }

    GUIChanged(evt) {
        //console.log(evt.detail.category, evt.detail.name, evt.detail.value);
        if (evt.detail.name == 'Visible') {
            //console.log('Change Model Visibility to', evt.detail.value);
            this.modelsWrapper.SetVisibility(evt.detail.value);
        }
        else if (evt.detail.name == 'Type') {
            this.modelsWrapper.SelectGroup(evt.detail.value);
        }
        else if (evt.detail.name == 'Configuration') {
            this.modelsWrapper.SelectItem(evt.detail.value);
        }
        else if (evt.detail.name == 'Angle') {
            const index = Math.round(evt.detail.value / evt.detail.step);
            this.modelsWrapper.SelectItem(index);
        }
        else if (evt.detail.name == 'Opacity') {
            this.modelsWrapper.SetOpacity(evt.detail.value);
        }


        if (evt.detail.name == 'Direction') {
            this.SetOrbitDirection(evt.detail.value);
        }
        else if (evt.detail.name == 'Speed') {
            this.SetOrbitSpeed(evt.detail.value);
        }
    }

    Disposed(evt) {
        //this.renderUtils.Dispose(evt.detail.objectname);
    }

    MoveComplete(evt) {
        for (const bill of this.billboardHelpers) {
            //現在の位置からビルボードの表示・非表示を設定
            bill.FilterConnectedBillboards(evt.detail.domeName);
        }
        for (const bill of this.billboard2DHelpers) {
            //現在の位置から2Dビルボードの表示・非表示を設定
            bill.FilterConnectedBillboards(evt.detail.domeName);
        }
    }
}